<template>
  <div class="page-content">
    <!-- MIGAS Y TÍTULO -->
    <nav class="page-breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">Inicio</li>
        <li class="breadcrumb-item active" aria-current="page">Novedades</li>
      </ol>
    </nav>

    <div class="row align-items-end mb-3">
      <!-- SELECT TIPO DE NOVEDAD -->
      <div class="col-md-4">
        <label class="form-label fw-bold mb-1" for="selNovedad">Tipo de novedad</label>
        <select id="selNovedad" class="form-control"
                v-model="filtros.novedad"
                @change="obtenerNovedades">
          <option disabled value="">Seleccione…</option>
          <option value="667">Día Food</option>
          <option value="666">Home Office</option>
          <option value="EX920">Eximición</option>
        </select>
      </div>

      <!-- SELECT AÑO -->
      <div class="col-md-2">
        <label class="form-label fw-bold mb-1" for="selAnio">Año</label>
        <select id="selAnio" class="form-control"
                v-model="filtros.anio"
                @change="obtenerNovedades">
          <option disabled value="">Año…</option>
          <option v-for="y in anios" :key="y" :value="y">{{ y }}</option>
        </select>
      </div>
    </div>

    <!-- SPINNER DE CARGA -->
    <lista-carga v-if="cargando"></lista-carga>

    <!-- TABLA -->
    <div class="row" v-show="!cargando">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <div class="table-responsive">
              <table id="novedades" class="table">
                <thead>
                  <tr>
                    <th>Status</th>
                    <th>Legajo</th>
                    <th>Nombre</th>
                    <th>Novedad</th>
                    <th>Desde</th>
                    <th>Hasta</th>
                    <th>Fecha carga</th>
                    <th>Responsable</th>
                    <th>Operación</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="n in novedades" :key="n.__id">
                    <td>
                      <span class="badge"
                            :class="n.status === 'Resuelto'
                                    ? 'badge-success'
                                    : 'badge-danger'">
                        {{ n.status }}
                      </span>
                    </td>
                    <td>{{ n.legajo }}</td>
                    <td>{{ n.nombre }}</td>
                    <td>{{ n.novedad }}</td>
                    <td>{{ n.desde }}</td>
                    <td>{{ n.hasta }}</td>
                    <td>{{ n.fecha }}</td>
                    <td>{{ n.responsable }}</td>
                    <td>{{ n.operacion_raiz }}</td>
                  </tr>
                </tbody>
              </table>
            </div> <!-- /.table-responsive -->
          </div> <!-- /.card-body -->
        </div> <!-- /.card -->
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import $ from 'jquery';
require('datatables.net');
require('datatables.net-buttons/js/buttons.colVis.js')();
require('datatables.net-buttons/js/buttons.html5.js')();
require('datatables.net-buttons/js/buttons.flash.js')();
require('datatables.net-buttons/js/buttons.print.js')();
import ListaCarga from '../ListaCarga.vue';

export default {
  name: 'Novedades',
  components: { ListaCarga },
  data() {
    const anioActual = new Date().getFullYear();   // 2025
    return {
      filtros: {
        novedad: '',
        anio: anioActual,
      },
      anios: Array.from({ length: anioActual - 2023 }, (_, i) => 2024 + i), // [2024, 2025]
      novedades: [],
      tablaDT: null,
      cargando: false,
    };
  },
  methods: {
    /* ---- Consulta a la API y refresco del DataTable ---- */
    async obtenerNovedades() {
      if (!this.filtros.novedad || !this.filtros.anio) return;

      // destruir DataTable anterior (si existe) antes de volver a pintar
      if (this.tablaDT) {
        this.tablaDT.destroy();
        this.tablaDT = null;
      }

      this.cargando = true;
      try {
        const url = `https://aplicativos.firebaseio.com/novedades_usuarios_test.json?orderBy=%22bejerman_id%22&equalTo=%22${this.filtros.novedad}%22&limitToLast=20000&print=pretty`;
        const { data } = await axios.get(url);

        /* Normalizamos el objeto devuelto a array
           y filtramos por año elegido en fecha_novedad */
        const lista = Object.entries(data || {})
          .map(([id, obj]) => ({ ...obj, __id: id }))
          .filter(item =>
            (item.fecha_novedad || item.fecha || '').startsWith(this.filtros.anio.toString())
          );

        this.novedades = lista;
        this.$nextTick(() => this.inicializarDataTable());
      } catch (err) {
        console.error('Error al obtener novedades', err);
      } finally {
        this.cargando = false;
      }
    },

    /* ---- Inicializa DataTable con idioma ES y botones ---- */
    inicializarDataTable() {
      this.tablaDT = $('#novedades').DataTable({
        language: {
          decimal: ',',
          thousands: '.',
          info: 'Mostrando _START_–_END_ de _TOTAL_',
          infoEmpty: 'Mostrando 0 de 0',
          infoFiltered: '(filtrado de _MAX_)',
          loadingRecords: 'Cargando…',
          lengthMenu: 'Mostrar _MENU_',
          paginate: { first: 'Primero', last: 'Último', next: '›', previous: '‹' },
          processing: 'Procesando…',
          search: 'Buscar:',
          zeroRecords: 'No hay resultados',
          emptyTable: 'Tabla vacía',
          aria: {
            sortAscending: ': ordenar ascendente',
            sortDescending: ': ordenar descendente',
          },
        },
        scrollX: false,
        dom: 'Bfrtip',
        responsive: true,
        buttons: ['copy', 'excel', 'csv', 'pdf'],
      });
    },
  },
  mounted() {
    // Llamada inicial (si querés arrancar vacío, comentá esta línea)
    this.obtenerNovedades();
  },
};
</script>

<style scoped>
/* badge-success y badge-danger ya vienen en Bootstrap; si no usás BS, agregalos: */
.badge-success { background-color:#10b759; color:#fff; }
.badge-danger  { background-color:#d33;    color:#fff; }
</style>
